<template>
    <layout>
        <div>Browse</div>
    </layout>
</template>

<script>
import Layout from '@/layouts/Layout.vue';

export default {
    components: {
        Layout,
    },
};
</script>
